import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

function Printer({ style }: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      height="31"
      style={style}
      viewBox="0 0 30 31"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7981_7689)">
        <circle
          cx="15"
          cy="15.5"
          fill="white"
          r="14.75"
          stroke="#9C9C9C"
          strokeWidth="0.5"
        />
        <path
          d="M9.95996 9.74805V9.63818C9.95996 8.60547 10.8169 8.13672 11.9009 8.13672H18.0972C19.2324 8.13672 20.0381 8.60547 20.0381 9.63818V9.74805H9.95996ZM11.1392 23.1001C10.231 23.1001 9.76953 22.6826 9.76953 21.7305V20.4487H9.28613C7.92383 20.4487 7.19141 19.7529 7.19141 18.3833V12.7656C7.19141 11.396 7.98975 10.6929 9.28613 10.6929H20.7119C22.0742 10.6929 22.8066 11.396 22.8066 12.7656V18.3833C22.8066 19.7529 22.0742 20.4487 20.7119 20.4487H20.2285V21.7305C20.2285 22.6826 19.7671 23.1001 18.8589 23.1001H11.1392ZM18.3462 13.022C18.3462 13.5273 18.7637 13.9229 19.2544 13.9155C19.7378 13.9155 20.1553 13.52 20.1553 13.022C20.1553 12.5386 19.7378 12.1211 19.2544 12.1211C18.7637 12.1211 18.3462 12.5386 18.3462 13.022ZM11.4688 22.0088H18.5366C18.8955 22.0088 19.064 21.833 19.064 21.4741V16.3618C19.064 16.0029 18.8955 15.8345 18.5366 15.8345H11.4688C11.1099 15.8345 10.9341 16.0029 10.9341 16.3618V21.4741C10.9341 21.833 11.1099 22.0088 11.4688 22.0088ZM12.6333 18.1782C12.377 18.1782 12.1865 17.9805 12.1865 17.7314C12.1865 17.4897 12.377 17.2993 12.6333 17.2993H17.3794C17.6284 17.2993 17.8188 17.4897 17.8188 17.7314C17.8188 17.9805 17.6284 18.1782 17.3794 18.1782H12.6333ZM12.6333 20.5732C12.377 20.5732 12.1865 20.3901 12.1865 20.1411C12.1865 19.8921 12.377 19.6943 12.6333 19.6943H17.3794C17.6284 19.6943 17.8188 19.8921 17.8188 20.1411C17.8188 20.3901 17.6284 20.5732 17.3794 20.5732H12.6333Z"
          fill="#363636"
        />
      </g>
      <defs>
        <clipPath id="clip0_7981_7689">
          <rect
            fill="white"
            height="30"
            transform="translate(0 0.5)"
            width="30"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Printer;
